import { Component } from '@angular/core';

@Component({
  selector: 'wchfs-nav-up-list-item',
  templateUrl: './nav-up-list-item.component.html',
  styleUrls: ['./nav-up-list-item.component.scss'],
})
export class NavUpListItemComponent {}
